import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 2L8.84708 6.1459H13.2063L9.67963 8.7082L11.0267 12.8541L7.5 10.2918L3.97329 12.8541L5.32037 8.7082L1.79366 6.1459H6.15292L7.5 2Z",
		fill: "#B9F833",
		stroke: "#B9F833"
	})
});
export default SvgStarFilled;
